import axios from 'axios';
import { getEnv } from '../config';

const API_URL = getEnv('REACT_APP_API_URL') || '';

export const announcementAPI = {
    getActive: () => axios.get(`${API_URL}/api/announcements`),
    getAll: () => axios.get(`${API_URL}/api/admin/announcements`),
    create: (data) => axios.post(`${API_URL}/api/admin/announcements`, data),
    update: (id, data) => axios.put(`${API_URL}/api/admin/announcements/${id}`, data),
    delete: (id) => axios.delete(`${API_URL}/api/admin/announcements/${id}`),
};
